import React, { FC } from "react";
import { MatterTemplateModal } from "@design-system";
import { useMatterTemplateFormViewModel } from "../../../hooks/matter-template";
import { useNavigate } from "react-router";
import { Path } from "../../../path";
import { PricingLevel, PricingType } from "~/graphql/types";
import { OperationVariables } from "@apollo/client";

export type MatterTemplateModalContainerProps = {
  onCancel: () => void;
  copiedTemplate?: {
    id: number;
    title: string;
  };
  refetchVariables: OperationVariables;
};

export const MatterTemplateModalContainer: FC<MatterTemplateModalContainerProps> = ({
  onCancel,
  copiedTemplate,
  refetchVariables,
}) => {
  const navigate = useNavigate();
  const vm = useMatterTemplateFormViewModel((id) => {
    navigate(Path.toMatterTemplateEditor(id));
  }, refetchVariables);

  return (
    <>
      <MatterTemplateModal
        show={true}
        loading={vm.loading()}
        saving={vm.saving()}
        alertMessage={vm.alertMessage()}
        practiceAreas={vm.practiceAreas() || []}
        onSave={({ title, practiceAreaId }) => {
          vm.createMatterTemplate(
            {
              organisationalUnit: { connect: { id: practiceAreaId } },
              title,
              pricingLevel: PricingLevel.None,
              pricingType: PricingType.None,
            },
            copiedTemplate?.id
          );
        }}
        initialValue={
          copiedTemplate && {
            title: `${copiedTemplate?.title} (Cloned) `,
          }
        }
        onCancel={onCancel}
      />
    </>
  );
};
